import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LeadSmsService {
  constructor(private api: ApiService) {}

  getConversationByLead(leadId: string): Observable<any> {
    return this.api.get(`/sms/conversations/by-lead/${encodeURIComponent(leadId)}`);
  }

  getMessagesByLead(leadId: string): Observable<any> {
    return this.api.get(`/sms/conversations/by-lead/${encodeURIComponent(leadId)}/messages`);
  }

  getConversations(params?: { lead_id?: string; office_id?: string }): Observable<any> {
    return this.api.get(`/sms/conversations`, params || {});
  }

  getMessagesByConversation(conversationId: string): Observable<any> {
    return this.api.get(`/sms/conversations/${encodeURIComponent(conversationId)}/messages`);
  }

  sendSms(leadId: string, message: string): Observable<any> {
    return this.api.post(`/sms/send`, { lead_id: leadId, message });
  }
}
